import React from 'react'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import ButtonRow from 'components/base/Button/Row'
import NewsItem from 'components/blocks/NewsItem'

import FeaturedNewsWrap from './styles'

const FeaturedNews: React.FC = (): React.ReactElement => (
  <FeaturedNewsWrap>
    <Content short={true} center={true}>
      <Title level={2}>In The News</Title>
      <NewsItem
        source='Press Release'
        title='Insurance Lounge Raises $15M Growth Equity to Fuel Rapid Expansion'
        linkUrl='/about-us/press/insurance-lounge-raises-15-million'
      />
      <NewsItem
        source='Agency Revolution'
        title='Insurance Lounge CEO Michael DeLaGrange Featured in Agency Revolution Podcast'
        linkUrl='https://www.agencyrevolution.com/blog/podcast/michael-delagrange-founder-president-of-insurance-lounge/'
      />
      <NewsItem
        source='Stitcher.com'
        title='Insurance Lounge Founder & CEO Featured on The Standout Millennial Show'
        linkUrl='https://www.stitcher.com/podcast/the-standout-millennial-show?fbclid=IwAR2Dv7Jqn0c59ETDM8Q8U8pRAcKy2K5jYJbDcpv9nTHJ65ghbKxQDSlsIBM'
      />
      <ButtonRow>
        <Link theme={LinkTheme.button} to='/about-us/news/'>
          Read More News
        </Link>
      </ButtonRow>
    </Content>
  </FeaturedNewsWrap>
)

export default FeaturedNews
